import MailingReview from './MailingReview'
import MailingExpertSelection from './MailingExpertSelection'
import Mailing from './Mailing'
import MailingSummary from './MailingSummary'
import MailingOverview from './MailingOverview'

export default [{
  path: '/project/:project_id/question/:question_id/mailingReview',
  name: 'MailingReview',
  component: MailingReview,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Mailing Review'}
}, {
  path: '/project/:project_id/question/:question_id/mailing/:mailing_id?',
  name: 'Mailing',
  component: Mailing,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Mailing'}
}, {
  path: '/project/:project_id/question/:question_id/mailing/:mailing_id/expertSelection',
  name: 'MailingExpertSelection',
  component: MailingExpertSelection,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Mailing Expert Selection'}
}, {
  path: '/project/:project_id/question/:question_id/mailing/:mailing_id/summary',
  name: 'MailingSummary',
  component: MailingSummary,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Mailing Summary'}
}, {
  path: '/mailing/:mailing_id/overview',
  name: 'MailingOverview',
  component: MailingOverview,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Mailing Overview'}
}
]



// WEBPACK FOOTER //
// ./src/pages/mailing/router.js